import axiosClient from "./axiosClient";

const BASE = "/admin/push";

// Tùy chọn hiển thị nâng cao (FCM). Tất cả optional.
export interface PushOptionsInput {
    image?: string;
    icon?: string;
    color?: string;
    badge?: number;
    priority?: "normal" | "high";
    silent?: boolean;
    ttl?: number;
    collapseKey?: string;
}

export interface BroadcastPayload extends PushOptionsInput {
    title: string;
    message: string;
    path?: string;
    url?: string;
    audience: object;
    createdBy?: string;
    scheduledAt?: number; // epoch ms; nếu là tương lai → hẹn giờ
    /**
     * queue = 1 job/người: chậm (~20 phút cho 30k) nhưng đo được ai bấm.
     * topic = 1 request FCM cho cả app: vài giây, nhưng KHÔNG lọc được người nhận
     * nên BE chỉ cho dùng với audience.mode = "all".
     */
    sendMode?: "queue" | "topic";
}

const pushBroadcastApi = {
    // Ảnh cho push: BE nén (ảnh lớn → JPEG ≤1024px, icon → PNG 256px) và trả URL tuyệt đối.
    uploadImage(file: File, kind: "image" | "icon") {
        const form = new FormData();
        form.append("kind", kind);
        form.append("image", file);
        return axiosClient.post(`${BASE}/upload-image`, form, {
            headers: { "Content-Type": "multipart/form-data" },
        });
    },
    preview(audience: object) {
        return axiosClient.post(`${BASE}/preview`, { audience });
    },
    // Forward toàn bộ payload (gồm rich options + scheduledAt) — BE tự whitelist.
    broadcast(payload: BroadcastPayload) {
        return axiosClient.post(`${BASE}/broadcast`, payload);
    },
    // Gửi thử tới 1 userId — không tạo bản ghi lịch sử.
    testSend(payload: PushOptionsInput & {
        title: string;
        message: string;
        path?: string;
        url?: string;
        userId: number;
    }) {
        return axiosClient.post(`${BASE}/test-send`, payload);
    },
    // Đăng ký toàn bộ token FCM cũ vào topic gửi-tất-cả. Chạy 1 lần là đủ; máy mới
    // tự vào topic lúc lưu token. Chạy lại vô hại (đăng ký trùng Google bỏ qua).
    syncTopic() {
        return axiosClient.post(`${BASE}/topic/sync`);
    },
    summary() {
        return axiosClient.get(`${BASE}/summary`);
    },
    listBroadcasts(params?: { limit?: number; offset?: number; status?: string }) {
        return axiosClient.get(`${BASE}/broadcasts`, { params });
    },
    getBroadcast(id: string) {
        return axiosClient.get(`${BASE}/broadcasts/${id}`);
    },
    cancelBroadcast(id: string) {
        return axiosClient.post(`${BASE}/broadcasts/${id}/cancel`);
    },
    deleteBroadcast(id: string) {
        return axiosClient.delete(`${BASE}/broadcasts/${id}`);
    },
};

export default pushBroadcastApi;
